/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationListResponseModel } from '../../models/organization-list-response-model';

export interface ConsumerOrganizationListGet$Params {
}

export function consumerOrganizationListGet(http: HttpClient, rootUrl: string, params?: ConsumerOrganizationListGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationListResponseModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerOrganizationListGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationListResponseModel>>;
    })
  );
}

consumerOrganizationListGet.PATH = '/Consumer/OrganizationList';
